<template>
    <modal
        name="avatar-update"
        height="auto"
        :adaptive="true"
    >
        <modal-skeleton @close="handleClose">
            <template slot="heading">
                Edit Profile Photo
            </template>
            <p>This can be a photo of you, your favorite TV character, or something else (it will be visible to all employees).</p>
            <div>
                <picture-input
                    ref="avatarInput"
                    width="200"
                    height="200"
                    radius="50"
                    :removable="true"
                    accept="image/jpeg,image/png"
                    :hide-change-button="false"
                    :z-index="1"
                    button-class="picture-input__button -change"
                    remove-button-class="picture-input__button -remove"
                    :prefill="avatar"
                    :prefill-options="{ fileType: 'jpg', mediaType: 'image/jpeg' }"
                    @change="handleImageChange"
                    @remove="handleImageRemove"
                />
            </div>
        </modal-skeleton>
    </modal>
</template>

<script>
import { mapActions } from 'vuex';

import PictureInput from 'vue-picture-input';
import ModalSkeleton from './ModalSkeleton.vue';

export default {
    name: 'AvatarUpdateModal',
    components: {
        ModalSkeleton,
        PictureInput,
    },
    props: {
        avatarUrl: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            image: '',
            avatar: this.avatarUrl,
        };
    },
    methods: {
        ...mapActions(['setAvatar']),
        handleClose() {
            this.$modal.hide('avatar-update');
        },
        handleImageRemove() {
            axios.post('/api/avatars', {
                remove_avatar: 1,
            }).then(() => {
                this.image = '';
            });
        },
        handleImageChange() {
            if (this.$refs.avatarInput.file) {
                this.image = this.$refs.avatarInput.file;
                this.attemptUpload().then((response) => {
                    this.setAvatar(response.data.data.avatar);
                    this.avatar = response.data.data.avatar;
                });
            } else {
                console.log('Old browser. No support for Filereader API');
            }
        },
        attemptUpload() {
            const formData = new FormData();
            formData.append('avatar', this.image);
            return axios.post('/api/avatars', formData,
                {
                    headers: {
                        'content-type': 'multipart/form-data',
                    },
                });
        },
    },
};
</script>
